const Marquee = ({ items, dark = false }) => (
  <div
    className={`overflow-hidden border-y py-5 ${
      dark ? 'border-white/10 bg-navy-light text-white/70' : 'border-line bg-mist text-ink/60'
    }`}
    data-testid="editorial-marquee"
  >
    <div className="animate-marquee flex w-max">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center" aria-hidden={dup === 1}>
          {items.map((item, i) => (
            <span key={i} className="flex items-center text-sm font-semibold uppercase tracking-[0.3em]">
              <span className="px-8">{item}</span>
              <span className="h-1.5 w-1.5 rounded-full bg-coral" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default Marquee;
